"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var SortButton_1 = __importDefault(require("../widgets/SortPanel/SortButton"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        filterPanel: (_a = {
                padding: theme.spacing(1.5)
            },
            _a[theme.breakpoints.up('md')] = {
                width: 300,
            },
            _a),
        headerText: {
            padding: theme.spacing(3.5),
        },
    });
});
/**
 * @component Filter dropdown that filters the search by the given labels.
 */
var FilterDrawer = function (_a) {
    var labels = _a.labels, selectedLabel = _a.selectedLabel, onClick = _a.onClick, isFilterOpen = _a.isFilterOpen, isMobileView = _a.isMobileView, setIsFilterOpen = _a.setIsFilterOpen;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useStyles();
    var handleDrawerClose = function () {
        setIsFilterOpen(false);
    };
    var getLabelText = function (label) {
        switch (label) {
            case t('text.links'):
                return t('text.search') + " " + t('text.links');
            case t('text.email'):
                return t('text.search') + " " + t('text.email');
            case t('directory.keyword'):
                return t('text.search') + " " + t('directory.keyword');
            case t('text.tags'):
                return t('text.search') + " " + t('text.tags');
            default:
                return '';
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isMobileView ? (react_1.default.createElement(core_1.Drawer, { anchor: "bottom", open: isFilterOpen, onBackdropClick: handleDrawerClose, onEscapeKeyDown: handleDrawerClose },
        react_1.default.createElement(core_1.Collapse, { in: isFilterOpen },
            react_1.default.createElement(core_1.Paper, { className: classes.filterPanel },
                react_1.default.createElement(core_1.Typography, { variant: "h4", className: classes.headerText }, t('text.search')),
                react_1.default.createElement(core_1.Divider, null),
                react_1.default.createElement(core_1.Grid, null, labels.map(function (label) { return (react_1.default.createElement(SortButton_1.default, { onClick: function () {
                        onClick(label);
                        setIsFilterOpen(false);
                    }, key: label, columnLabel: label, isSelected: label === selectedLabel })); })))))) : (react_1.default.createElement(core_1.Collapse, { in: isFilterOpen },
        react_1.default.createElement(core_1.Paper, { className: classes.filterPanel },
            react_1.default.createElement(core_1.Grid, null, labels.map(function (label) { return (react_1.default.createElement(SortButton_1.default, { onClick: function () {
                    onClick(label);
                    setIsFilterOpen(false);
                }, key: label, columnLabel: getLabelText(label), isSelected: label === selectedLabel })); })))))));
};
exports.default = FilterDrawer;
